export default {
      id: "ic_b_logo-usage",
      viewBox: "0 0 36 36",
      url: "/" + "images/icons.3.109.2.svg#ic_b_logo-usage",
      toString: function () {
        return this.url;
      }
    }